import axios from "axios";
import { TTP_API_URL } from "Config";

export const saveUpload = ({ token, file, onProgress, email }) => {
  const requestUrl = `${TTP_API_URL}/dir/document`;
  let config = {};
  if (onProgress) {
    config.onUploadProgress = progressEvent => {
      let percentCompleted = Math.floor(
        (progressEvent.loaded * 100) / progressEvent.total
      );
      onProgress(percentCompleted);
    };
  }

  let formData = new FormData();
  formData.append("access_token", token);
  formData.append("deliverOnce", 0);
  formData.append("senderConfirmationEmail", email);

  file && formData.append("file", file);

  return axios.post(requestUrl, formData, config);
};

export const sendUrl = ({ token, url, communityId }) => {
  const requestUrl = `${TTP_API_URL}/dir/document-or-link`;
  //const requestUrl = `https://api.v2.tamtam.pro/dir/document-or-link`;

  let formData = new FormData();
  formData.append("access_token", token);
  formData.append("deliverOnce", 0);
  //formData.append("access_token", "000076888ed482e12afe88a780a85b8a1685d20d");
  formData.append("url", url);

  return axios.post(requestUrl, formData);
};



// WEBPACK FOOTER //
// ./src/api/wheretobill.js